import * as React from "react";
import { MenuItem } from "@chakra-ui/react";
import { IoTrashOutline } from "react-icons/io5";
import { Modal } from "components";
import { useDelete } from "./duck";

const Remove: React.FC = () => {
  const { onConfirm, names } = useDelete();

  return (
    <Modal.Confirm
      onConfirm={onConfirm}
      confirmText="Remove"
      successMessage={
        names.length > 1
          ? "Cases are deleted successfully."
          : "Case is deleted successfully."
      }
      title={`Do you want to remove case(s) ${names.join(", ")} ?`}
    >
      <MenuItem
        color="red.600"
        fontSize="sm"
        icon={<IoTrashOutline size="12px" />}
      >
        Remove
      </MenuItem>
    </Modal.Confirm>
  );
};

export default Remove;
